import React, { useEffect } from "react";
import Lmsbanner from "./Lmsbanner";
import Lmsabout from "./Lmsabout";
import Lmswhy from "./Lmswhy";
import Lmscards from "./Lmscards";
import Lmsenquire from "./Lmsenquire";
import Lmsfeatures1 from "./Lmsfeatures1";

const Lmspage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Lmsbanner/>

      <Lmsabout/>
       <Lmsfeatures1/>
      <Lmswhy/>
      {/* <Lmsenquire/> */}
      <Lmscards/>
    </div>
  );
};

export default Lmspage;
